import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtTabController from "../../components/NtTabController";
import NtModalInputTitle from "../../components/NtModalInputTitle";
import { useTheme } from "../../context/ThemeContext";
import hardwareringtonedata from "../data/hardwareringtonedata";

function NtHardwareRingtonePicker({ containerStyle, selection, onPress }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={[styles.container, containerStyle]}>
      <NtModalInputTitle style={{ marginLeft: 4, marginBottom: 4 }}>
        Ring Tone *
      </NtModalInputTitle>
      <NtTabController
        options={hardwareringtonedata}
        selection={selection}
        onPress={onPress}
      />
    </View>
  );
}

const makeStyles = () => StyleSheet.create({
  container: { marginBottom: 8 },
});

export default NtHardwareRingtonePicker;
